<template>
  <section class="section bg is-medium">
    <div class="container">
      <h1
        class="title is-3 is-size-3-mobile is-uppercase has-text-centered has-text-light"
      >Special Programs</h1>
      <div class="columns is-multiline has-text-weight-bold">
        <div
          class="column card drop-shadow has-text-black"
          :style="{ backgroundImage: 'url(' + vip + ')' }"
        >
          <div class="gradient">
            <p class="vip-title is-uppercase is-size-4">SYNERGY RETREAT</p>
            <p
              class="vip-body"
            >Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum dignissimos nobis expedita repellat at officiis esse amet iste voluptatibus. Deserunt soluta facere vero necessitatibus! Assumenda iusto ipsa alias velit enim.</p>
          </div>
        </div>
        <div
          class="column card drop-shadow has-text-black"
          :style="{ backgroundImage: 'url(' + vip2 + ')' }"
        >
          <div class="gradient">
            <p class="vip-title is-uppercase is-size-4">Street Fighting Secrets</p>
            <p class="vip-body">
              The worlds most intelligent self protection system
              <br />Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum dignissimos nobis expedita repellat at officiis esse amet iste voluptatibus. Deserunt soluta facere vero necessitatibus! Assumenda iusto ipsa alias velit enim.
            </p>
          </div>
        </div>
        <div
          class="column card drop-shadow has-text-black"
          :style="{ backgroundImage: 'url(' + vip3 + ')' }"
        >
          <div class="gradient">
            <p class="vip-title is-uppercase is-size-4">9 week body transformation</p>
            <p
              class="vip-body"
            >Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum dignissimos nobis expedita repellat at officiis esse amet iste voluptatibus. Deserunt soluta facere vero necessitatibus! Assumenda iusto ipsa alias velit enim.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      vip: require("@/assets/vip/synergy-retreat.jpg"),
      vip2: require("@/assets/vip/sfs.jpg"),
      vip3: require("@/assets/vip/pt.jpg")
    };
  }
};
</script>

<style lang="scss" scoped>
.gradient {
  background-image: linear-gradient(
    rgba(30, 30, 30, 1),
    rgba(0, 0, 0, 0.5),
    #ffffff00
  );
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 2em;
  border-radius: 10px;
  word-wrap: break-word;
}

.title {
  margin-bottom: 2em !important;
}

.vip-title {
  color: whitesmoke;
  text-shadow: 1px 1px 5px rgb(36, 36, 36) !important;
  padding-bottom: 1rem;
}

.vip-body {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  color: rgb(200, 200, 200);
  font-weight: 300;
}

.bg {
  background-color: rgb(13, 13, 13);
}

.card {
  background-color: rgb(22, 22, 22);
  padding: 2em;
  margin: 0.75em;
  height: 300px;
  box-shadow: 0 3px 15px rgb(17, 17, 17) !important;
  color: white;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-radius: 10px;
  // opacity: 0.2;
}

@media screen and (max-width: 768px) {
  .card {
    background-color: rgb(22, 22, 22);
    padding: 2em;
    margin: 1rem 1rem 2rem 10px;
    height: 50vh !important;
    border-radius: 10px;
    color: white;
  }
}
</style>
